






























import { Vue, Component } from 'vue-property-decorator';
import CommonTable, { TableColumn } from '../../components/organisms/CommonTable.vue';
import { TeacherService } from '../../biz/remote/TeacherService';
import { TeacherInfoInputDTO } from '../../../src_server/entity/dto/TeacherInfoInputDTO';
import { MessageDialog } from '../../utils/MessageDialog';
import { NotifyMail } from './NotifyMail';
import TeacherInfoMaintenance from './TeacherInfoMaintenance.vue';
import { dayjs, DT_FORMAT_JA } from '../../../src_server/common/momentExtends';
import { ActorType, ActorTypeNames } from '../../../src_server/biz/ActorType';
import { getCircleOBuilding } from '../../../src_server/entity/master/buildingData';
import TeacherInteviewDialog from './TeacherInteviewDialog.vue';
@Component({
  components: { TeacherInfoMaintenance, CommonTable, TeacherInteviewDialog },
})
export default class TeacherSelectionListPage extends Vue {
  private loading = false;
  public teacherCols: TableColumn[] = [
    { label: 'no', type: 'seq' },
    {
      label: '詳細',
      btnClass: { btn: true, 'clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-405rem': true },
      onclick: this.detail,
    },
    {
      label: '面接',
      btnClass: { btn: true, 'clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-405rem': true },
      onclick: this.interview,
    },
    {
      label: '面接資料',
      btnClass: { btn: true, 'clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-405rem': true },
      onclick: this.interviewDocumnet,
    },
    {
      label: '採用メール',
      btnClass: { btn: true, 'clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-605rem': true },
      onclick: this.successMail,
    },
    {
      label: '採用確定',
      btnClass: { btn: true, 'clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-505rem': true },
      onclick: this.success,
    },

    {
      label: '',
      type: 'renderfunc',
      representedAs: (row: TeacherInfoInputDTO) => {
        return `<a href="${row.teacher.img_path}" target="_blank" ><img class="rounded-circle shadow"  height="60px" src="${row.teacher.img_path}" /></a>`;
      },
    },

    {
      label: '氏名',
      // name: 'teacher.full_name',
      // headerClass: 'table-primary',
      type: 'renderfunc',
      representedAs: (row: any) => {
        const actor = ActorType.getInstanceByName(row.communicate.actor_type as ActorTypeNames);

        return `<div>${row.teacher.full_name}</div>
          <div>${row.teacher.gender}</div>
        `;
      },
      width: '100px',
    },
    {
      label: '申込日',
      type: 'renderfunc',
      representedAs: (row: any) => {
        return `<div class="fz-xsm">${dayjs(row.teacher.application_dt).format('YYYY年MM月DD日')}</div>
        <div class="fz-xsm">${dayjs(row.teacher.application_dt).format('HH:mm')}</div>`;
      },
      width: '125px',
    },
    { label: '資格', name: 'teacher.qualification', width: '125px' },
    {
      label: '所属/最終学歴',
      type: 'renderfunc',
      representedAs: (row: TeacherInfoInputDTO) => {
        return `<div>${row.teacher.work_place}</div>
        <br>
        <div>${row.teacher.school_name}</div>
        <div>${row.teacher.final_education}</div>`;
      },
      width: '125px',
    },
    { label: '退会予定', name: 'teacher.time_to_quit' },
    { label: '都道府県', name: 'teacher.prefecture' },

    {
      label: '落選メール',
      btnClass: { btn: true, 'font-weight-700 bg-red hvr-bg-red clr-wht hvr-clr-red rounded-xl btn-neumo btn-neumo-red bsd bc-wht bw-02r w-605rem': true },
      onclick: this.failuerMail,
    },
    {
      label: '落選処理',
      btnClass: { btn: true, 'font-weight-700 bg-red hvr-bg-red clr-wht hvr-clr-red rounded-xl btn-neumo btn-neumo-red bsd bc-wht bw-02r w-505rem': true },
      onclick: this.failuer,
    },
  ];

  /**
   * 面接のイベントハンドラ
   */
  interview(row: any) {
    const name = `${row.teacher.full_name}`;
    const mail = row.teacher.email;
    const notify = new NotifyMail();
    notify.openMailToAppoint(mail, name);
  }

  /**
   * 面接資料のイベントハンドラ
   */
  interviewDocumnet(row: any) {
    const dialog = this.$refs['teacher_inteview_dialog'] as TeacherInteviewDialog;
    dialog.show(row.teacher);
  }

  /**
   * 落選チェック（不採用通知）
   */
  async failuer(row: any) {
    const name = `${row.teacher.full_name}`;
    const result = await MessageDialog.confirm(`${name}さんを不採用にします。よろしいですか？（この操作は取り消せません）。メールは「落選メール」ボタンより別途送信してください`);
    if (!result) return;

    // 不採用
    const user_id = row.teacher.user_id;
    const email = row.teacher.email;
    const res = await this.biz.sendFailureAnnounce(user_id, email, name);
    if (res.hasError) {
      await MessageDialog.alert(res.errorDescription);
      return;
    }
    this.loadData();
  }

  /**
   * 落選メール
   */
  async failuerMail(row: any) {
    const name = `${row.teacher.full_name}`;
    const mail = row.teacher.email;
    const notify = new NotifyMail();
    notify.openMailToFailur(mail, name);
  }

  /**
   * 採用確定ボタンのハンドラ
   */
  async success(row: any) {
    const name = `${row.teacher.full_name}`;

    const result = await MessageDialog.confirm(`${name}さんの採用を確定します。よろしいですか？（この操作は取り消せません）`);
    if (!result) return;

    // 採用
    const user_id = row.teacher.user_id;
    const res = await this.biz.sendSuccessCommit(user_id, getCircleOBuilding());
    if (res.hasError) {
      await MessageDialog.alert(res.errorDescription);
      return;
    }
    this.loadData();
  }

  /**
   * 採用通知メールの送信
   */
  async successMail(row: any) {
    await MessageDialog.alertModal(`採用通知メールを起動します。メールを送信したらすぐに「採用確定」を実施してください。`);

    const name = `${row.teacher.full_name}`;
    const user_id = row.teacher.user_id;
    const email = row.teacher.email;
    const res = await this.biz.getSuccessMailMessage(user_id, email, name, getCircleOBuilding());
    if (res.hasError) {
      await MessageDialog.alert(res.errorDescription);
      return;
    }
    const mail = res.data;
    const notify = new NotifyMail();
    notify.openMailWindow(email, mail.subject, mail.body);
  }

  detail(row: any) {
    const dialog = this.$refs['teacher_detail_dialog'] as TeacherInfoMaintenance;
    dialog.show(row);
  }

  cancel() {
    const dialog = this.$refs['teacher_detail_dialog'] as TeacherInfoMaintenance;
    dialog.hide();
  }

  private biz = new TeacherService();

  private teacherRows: TeacherInfoInputDTO[] = [];

  private selectedTeacher = {};

  loadData() {
    this.loading = true;
    this.biz.getAllTeacherCandidateInfo().then((res) => {
      this.loading = false;
      this.teacherRows = res.data;
      // console.log('this.teacherRows', this.teacherRows);
    });
  }

  get model() {
    return this.teacherRows;
    // .filter((r) => {
    //   const filter = r.teacher.full_name?.indexOf(this.name_filter);
    //   if (this.name_filter === '' || !filter) return true;
    //   return filter > 0;
    // })
    // .filter((r) => {
    //   const school_selected = r.teacher.school_name?.indexOf(this.school_filter);
    //   const last_selected = r.teacher.final_education?.indexOf(this.school_filter);
    //   if (this.school_filter === '' || !school_selected || !last_selected) return true;
    //   return school_selected > 0 || last_selected > 0;
    // })
  }
  mounted() {
    this.loadData();
  }
}
